import React from 'react';
import AdminDashboardSection from '../../sections/AdminDashboard/AdminDashboard';

const AdminDashboard = () => {
  return <AdminDashboardSection />;
};

export default AdminDashboard;
